import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styles from './form-dialog.module.scss';
import IconButton from '../icon-button/icon-button';
import Images from 'assets/Images';

export default function FormDialog({
  children,
  open,
  handleClose,
  title,
  handleSubmit,
  enableButton,
  size,
  padding = true,
  width = 600,
  type = 'default',
  className = 'dialog-wrapper',
  custompd,
  showCloseIcon = true
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        className={`dialog-${size} ${className}`}
      >
        <header className="dialog_header" style={{ backgroundColor: type !== 'default' ? '#FF4267' : '#1739B0' }}>
          <DialogTitle>
            {title}
          </DialogTitle>
          {showCloseIcon
          && <IconButton icon={Images.CLOSE_WHITE} onClick={handleClose} />}
        </header>
        <DialogContent>
          <div style={padding ? { padding: '20px', width: `${width}px` } : { padding: '0px', minWidth: `${width}px` }} className={` ${styles.dialog_sm} ${custompd}`}>
            {children}
          </div>
        </DialogContent>
        { enableButton
        && (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit}>Ok</Button>
          </DialogActions>
        ) }
      </Dialog>
    </div>
  );
}
